import { all, fork, put, take } from 'redux-saga/effects';

import { NORMALIZE_ALL, SAVE_ANNOTATIONS } from './actions';
import {
  //bookmarks as nmBookmarks,
  highlightsAndNotes as nmHighlightsAndNotes,
  markers as nmMarkers
} from 'lib/normalizers';
import notebookFilterMarkers from 'lib/notebookFilterMarkers';


function* normalizeAll() {
  const { data:{ /*vsBookmarks, */ vsHighlightsAndMarkers } } = yield take(NORMALIZE_ALL);

  console.time('normalizeAll#normalizeAll')
  const { highlights, markers } = vsHighlightsAndMarkers;

  yield fork(nmMarkers, markers);

  const [/*bookmarks,*/ highlightsAndNotes] = yield all([
    // nmBookmarks(vsBookmarks),
    nmHighlightsAndNotes(highlights)
  ]);

  yield fork(notebookFilterMarkers, highlightsAndNotes[0], markers);
  yield put({ type: SAVE_ANNOTATIONS, data: [/*bookmarks,*/ highlightsAndNotes] });
  console.timeEnd('normalizeAll#normalizeAll')
}


export default normalizeAll;
